/**
 * Canonical taxonomy lists (mirrors backend/taxonomies.py).
 * Frontend uses these for filter sidebars and forms.
 */
export const PROVIDER_TYPES = [
  "Device manufacturer", "Software platform", "Visibility platform",
  "Smart label provider", "GPS tracker provider", "BLE tag provider",
  "IoT sensor provider", "Satellite/NTN tracking provider",
  "Cold chain monitoring provider", "Asset tracking provider",
  "Fleet tracking provider", "Returnable packaging tracking provider",
  "System integrator", "Distributor/reseller", "Data/API provider",
  "Connectivity/network provider",
];

export const SOLUTION_CATEGORIES = [
  "Shipment tracking", "Asset tracking", "Cold chain monitoring",
  "Real-time location tracking", "Returnable packaging tracking",
  "Fixed condition monitoring", "Intralogistics", "Warehouse asset tracking",
  "Fleet tracking", "Container tracking", "Pallet tracking", "Parcel tracking",
  "High-value goods tracking", "Pharma logistics", "Food logistics",
  "Manufacturing visibility", "Equipment tracking", "Trailer tracking",
  "Yard tracking", "BLE location tracking", "Indoor positioning",
  "IoT condition monitoring",
];

export const DEVICE_TYPES = [
  "GPS tracker", "Cellular tracker", "BLE tag", "Smart label", "Data logger",
  "Temperature logger", "Reusable tracker", "Single-use tracker", "Gateway",
  "Fixed sensor", "Beacon", "Pallet tracker", "Container tracker",
  "Trailer tracker", "Asset tag", "Wearable tracker", "Satellite tracker",
  "Hybrid tracker", "Software-only platform", "API-only platform",
];

export const CONNECTIVITY = [
  "GPS/GNSS", "Cellular location", "Wi-Fi positioning", "Bluetooth Low Energy",
  "RFID", "NFC", "LoRaWAN", "Sigfox", "NB-IoT", "LTE-M", "4G LTE", "5G",
  "Satellite", "NTN", "UWB", "Hybrid positioning",
];

export const SENSORS = [
  "Temperature", "2°C to 8°C temperature", "Frozen temperature",
  "Ultra-low temperature", "Humidity", "Light", "Shock", "Tilt",
  "Pressure", "CO2", "Door open/close", "Motion", "Vibration",
  "Tamper detection", "Battery level",
];

export const BATTERY_LIFE = [
  "Less than 7 days", "7 to 30 days", "1 to 3 months",
  "3 to 6 months", "6 to 12 months", "12+ months", "Multi-year",
  "Rechargeable", "Mains powered", "Battery-free / passive",
];

export const COMMERCIAL_MODELS = [
  "Device purchase", "Device rental", "Device and software bundle",
  "SaaS subscription", "Per shipment pricing", "Per device per month",
  "Annual contract", "Free trial", "API pricing", "Custom quote required",
];

export const COMPLIANCE = [
  "Airline approved", "CE", "FCC", "UKCA", "GxP", "GDP",
  "FDA 21 CFR Part 11", "ISO 9001", "ISO 27001", "IP rating",
  "ATEX", "Pharma validated", "Food logistics suitable",
];

export const INDUSTRIES = [
  "Life sciences and pharma", "Healthcare", "Food and beverage",
  "Retail", "Automotive", "Manufacturing", "Aerospace", "Defence",
  "Oil and gas", "Logistics", "Transportation", "Warehousing",
  "Cold chain", "Luxury goods", "Electronics", "Chemicals", "Agriculture",
];

export const USE_CASES = [
  "Reduce shipment loss", "Monitor temperature excursions",
  "Prove chain of custody", "Track returnable assets",
  "Improve pallet visibility", "Monitor high-value goods",
  "Improve cold chain compliance", "Monitor warehouse assets",
  "Track unpowered assets", "Track pharma shipments",
  "Detect shock or mishandling", "Improve ETA visibility",
];

export const TIERS = ["Basic", "Verified", "Featured"];

export const COUNTRIES_SUGGESTED = [
  "United States", "United Kingdom", "Germany", "France", "Netherlands",
  "Singapore", "Switzerland", "Sweden", "Canada", "Australia", "India",
  "China", "Japan", "Israel", "Italy", "Spain", "Ireland",
];
